exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}html,body{margin:0;padding:0;height:inherit}", ""]);

